import { render } from "./V1PaymentProvidersView.vue?vue&type=template&id=9f7eb780&scoped=true&ts=true"
import script from "./V1PaymentProvidersView.vue?vue&type=script&lang=ts"
export * from "./V1PaymentProvidersView.vue?vue&type=script&lang=ts"

import "./V1PaymentProvidersView.vue?vue&type=style&index=0&id=9f7eb780&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f7eb780"]])

export default __exports__